<template>
	<article>
		<Notification ref="notif" :closed="true" corner="bottom-right" style="color:#061529;"/>
		<div class="cover">
			<!-- <img :src="objeto.imagemCapa" :alt="objeto.nome" /> -->
			<i class="fas fa-folder"></i>
			<div class="descricao">Coleção</div>
			<!-- <img src="@/assets/images/1@2x.png" :alt="colecao.nome" /> -->
		</div>

		<div class="infos">
			<div class="controls">
				<!-- <button type="button" class="btn small" @click="$router.push( '/visualizarColecao/' + colecao.id )"><i class="fas fa-eye"></i></button>-->
				<router-link class="btn small" title="Vizualizar coleção" :to="{ name: 'visualizarColecao', query: { id: colecao.id } }"><i class="fas fa-eye"></i></router-link>
				<button class="btn small" title="Clonar coleção" type="button" @click="clonar()"><i class="fas fa-clone"></i></button>
				<div class="more">
					<div class="credits">
						<p>
							<strong>Autor: </strong> {{ colecao.autor }}
						</p>
					</div>
				</div>
			</div>
			<div class="title-description">
				<h2>
					<router-link :to="{ name: 'visualizarColecao', query: { id: colecao.id } }">{{ colecao.nome }}</router-link>
				</h2>

				<div class="description">
					{{ colecao.descricao }}
				</div>
			</div>
		</div>
		<!-- Modal -->
		<ModalEdit v-show="isModalVisible">
			<template v-slot:body>
				<form @submit.prevent>
					<div class="row full">
						<div>
							<label>Deseja clonar a coleção:  <span>{{ colecao.nome }}?</span></label>
						</div>
					</div>
					<div class="actions">
						<button @click="confirm(colecao.id)">CONFIRMAR</button>
						<button @click="cancelar">CANCELAR</button>
					</div>
				</form>
			</template>
		</ModalEdit>
		<!-- Final modal -->
	</article>

</template>

<script>
import ModalEdit from '@/components/shared/ModalEdit'
import { colecoes } from '@/services/colecoes'

export default {
	name: 'BoxObjetos',
	components: { ModalEdit },
	props: {
		colecao: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			boxCadastro: false,
			objetoId: null,
			isModalVisible: false,
			data: {},
			status: ''
		}
	},
	methods: {
		clonar () {
			this.isModalVisible = true
		},
		cancelar () {
			this.isModalVisible = false
		},
		async confirm (id) {
			await colecoes.clonar(id)
				.then(res => {
					this.data = res.data
					this.status = res.status
				})
				.catch(err => console.log(err))

			if (this.status === 200) {
				this.$router.push({ name: 'visualizarColecao', params: { message: 'Clonado com Sucesso !' }, query: { id: this.data.id } })
			} else {
				window.notificationEM.open('', `Erro ao clonar ${this.status}`, 'error')
			}

			this.isModalVisible = false
		}
	}
}
</script>

<style lang="scss" scoped>
article {
	display: grid;
	grid-template-columns: 240px auto;
	grid-gap: 0 30px;
	border-bottom: 2px solid #59708F;
	padding-bottom: 10px;

	&:not(:last-of-type) {
		margin-bottom: 50px;
	}

	.cover {
		background-color: #223244;
		height: 144px;
		align-items: center;
		justify-content: center;
		display: flex;
		background-image: url('../../../../assets/images/bg1_colecao_lista.png');
		background-repeat: no-repeat;
		color: #FFF;
		width: 240px;
		flex-direction: column;
		.fa-folder {
			font-size: 50px;
		}
		.descricao {
			font: Condensed Bold 30px/39px Roboto;
		}
	}

	.infos {
		.title-description {
			h2 {
				font-size: 1.5em;
				font-weight: 700;
				margin-top: 10px;
				text-transform: uppercase;
				margin-bottom: 10px;

				a {
					text-decoration: none;
					color: inherit;
				}
			}

			.description {
				margin-bottom: 14px;
				height: 4.6em;
				overflow: hidden;
			}
		}

		.controls {
				display: flex;
				padding: 0;

				.btn {
					background: $second-color;
					border: none;
					color: #fff;
					text-decoration: none;
					display: flex;
					justify-content: center;
					align-items: center;
					min-width: 40px;
					min-height: 40px;
					font-size: 1em;
					padding: 2px 10px;
					border-radius: 5px;
					font-weight: 700;
					margin-right: 10px;
					a {
						width: 30px;
						height: 40px;
					}
				}

				button {
					margin-right: 10px;
					cursor: pointer;
				}

				.more {
					// display: grid;
					// grid-template-columns: auto 190px;
					// grid-gap: 0 40px;
					// align-items: center;
					display: flex;
					justify-content: flex-end;
					width: 100%;

					.credits {
						display: flex;
						color: #8B94a7;

						p {
							&:not(:last-of-type) {
								margin-right: 20px;
							}

							&:first-of-type {
								display: flex;
								align-items: center;

								i {
									font-size: 1.3em;
									margin-right: 6px;
								}
							}

							strong {
								font-weight: 700;
								margin-right: 2px;
							}
						}
					}
				}
			}

		// .more {
		// 	// display: grid;
		// 	// grid-template-columns: auto 190px;
		// 	// grid-gap: 0 40px;
		// 	// align-items: center;
		// 	display: flex;
		// 	justify-content: flex-end;
		// 	margin-top: 20px;

		// 	.credits {
		// 		display: flex;
		// 		color: #8B94a7;

		// 		p {
		// 			&:not(:last-of-type) {
		// 				margin-right: 20px;
		// 			}

		// 			&:first-of-type {
		// 				display: flex;
		// 				align-items: center;

		// 				i {
		// 					font-size: 1.3em;
		// 					margin-right: 6px;
		// 				}
		// 			}

		// 			strong {
		// 				font-weight: 700;
		// 				margin-right: 2px;
		// 			}
		// 		}
		// 	}
		// }
	}
	form {
		width: 100%;
		background-color: #fff;
		padding: 15px;
		margin-top: 50px;
		.row {
			display: flex;
			margin: 0 auto;
			justify-content: space-between;
			margin-top: 35px;
			label {
				display: block;
				display: flex;
				justify-content: center;
				margin-bottom: 5px;
				color: #052354;
				font-weight: bold;

				span {
					text-transform: uppercase;
					margin-left: 10px;
				}
			}
		}
		.full {
			input {
				width: 634px;
			}
		}
	}
	.actions {
		margin-top: 40px;
		display: flex;
		justify-content: flex-end;
		button:first-child {
			margin-right: 10px;
			background-color: #fff;
			color: #000;
			border: 1px solid #06162B;
		}
		button:nth-child(2n) {
			background-color: #00659D;
			color: #fff;
			border: 1px solid #00659D;
		}
		button {
			border-radius: 5px;
			height: 47px;
			width: 136px;
			font-weight: bold;
		}
	}
}
</style>
